"use client";

import React from "react";
import { useAuth } from "@/hooks/useAuth";

export const SignOutMobileButton = () => {
  const { signOut } = useAuth();
  return (
    <button
      onClick={signOut}
      className="text-[#808080] hover:text-white text-sm font-medium transition-colors cursor-pointer text-left"
    >
      Sign Out
    </button>
  );
};
